import { useQuery } from '@tanstack/react-query';

import { client } from '../client';
import { QueryKeys } from '../query-keys';

import type { Bundle } from '../../types/Policy';

type PolicyList = {
  result: {
    policies: Bundle[];
  };
};

export const getPoliciesForCustomer = async (customerUuid: string) => {
  const policies = await client.get<PolicyList>(`/v1/impersonate/${customerUuid}`);
  return policies.data.result.policies;
};

export const usePoliciesForCustomer = (customerUuid: string) => {
  return useQuery({
    queryKey: QueryKeys.AdminPolicies(customerUuid),
    queryFn: async () => {
      const res = await getPoliciesForCustomer(customerUuid);
      return res;
    },
    enabled: false, // hacky to set enabled just to expose the refetch function?
  });
};
